import { render } from "./ExpandableProjectMedia.vue?vue&type=template&id=6a7fa959&scoped=true"
import script from "./ExpandableProjectMedia.vue?vue&type=script&lang=js"
export * from "./ExpandableProjectMedia.vue?vue&type=script&lang=js"

import "./ExpandableProjectMedia.vue?vue&type=style&index=0&id=6a7fa959&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7fa959"]])

export default __exports__